<template>
    <div
        :class="`my-ticket-icon my-ticket-icon--${ticketType}`"
        class="my-ticket__progress"
        v-if="
            ticketType === 'in-progress' &&
            betTypeRef != BetTypeRef.SINGLE &&
            betTypeRef != BetTypeRef.KOMBI &&
            outcomesProgress > 0
        "
    >
        <svg :style="`--progress-value: ${outcomesProgress};`">
            <circle class="my-ticket__progress__track" :class="{ 'my-ticket__progress__track--white': whiteTrack }" />
            <circle class="my-ticket__progress__value" />
        </svg>
        <SvgIcon name="part-win" />
    </div>
    <SvgIcon
        v-else-if="outcomesProgress == 0"
        :class="`my-ticket-icon my-ticket-icon--time`"
        :name="getTicketIconName(ticketType)"
        :size="svgSize"
    />
    <SvgIcon
        v-else
        :class="`my-ticket-icon my-ticket-icon--${ticketType}`"
        :name="getTicketIconName(ticketType)"
        :size="svgSize"
    />
</template>
<script lang="ts" setup>
import { computed } from "vue";
import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import { TicketLeg } from "@/shared/model/ticket";
import { BetTypeRef } from "@/shared/model/bet";
const props = withDefaults(
    defineProps<{
        legs?: TicketLeg[];
        ticketType: string;
        betTypeRef: string;
        svgSize?: number;
        whiteTrack?: boolean;
    }>(),
    {
        svgSize: 20,
        whiteTrack: false,
    },
);

const outcomesProgress = computed(() => {
    let resulted = 0;
    let total = 0;
    props.legs?.forEach((leg) => {
        leg.outcomes.forEach((outcome) => {
            if (outcome.outcomeDetails.result) {
                resulted++;
            }
            total++;
        });
    });

    return total > 0 ? resulted / total : 0;
});

const getTicketIconName = (ticketType: string) => {
    switch (ticketType) {
        case "in-progress":
            return "time";
        case "win":
            return "win";
        case "lose":
            return "lose";
        case "cashout":
            return "cashout-2";
        case "return":
            return "return";
        default:
            return "time";
    }
};
</script>
